"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const SimpleInput_1 = __importDefault(require("../inputs/SimpleInput"));
const WidgetDatePicker_1 = __importDefault(require("../inputs/WidgetDatePicker"));
const WidgetDropdownList_1 = __importDefault(require("../inputs/WidgetDropdownList"));
const WidgetMultiselect_1 = __importDefault(require("../inputs/WidgetMultiselect"));
const FormControls_1 = __importDefault(require("../controls/FormControls"));
exports.default = (0, mobx_react_1.observer)(({ form }) => (react_1.default.createElement("form", null,
    react_1.default.createElement("h2", { className: "light-red" }, "Form Company"),
    react_1.default.createElement("h4", null, "React Widgets"),
    react_1.default.createElement(SimpleInput_1.default, { field: form.$('name') }),
    react_1.default.createElement(SimpleInput_1.default, { field: form.$('revenue') }),
    react_1.default.createElement(SimpleInput_1.default, { field: form.$('assets') }),
    react_1.default.createElement(WidgetDatePicker_1.default, { field: form.$('founded') }),
    react_1.default.createElement(WidgetDropdownList_1.default, { field: form.$('productsDropdown') }),
    react_1.default.createElement(WidgetMultiselect_1.default, { field: form.$('productsMultiselect') }),
    react_1.default.createElement(FormControls_1.default, { form: form }))));
